import { createStyles } from '@jwp/ott-common/src/modules/container';

import baseStyles from './VideoTags.module.scss';

export const VideoTagsIdentifier = Symbol(`VIDEO_FORMATS`);

const VideoTags = ({ attributes }: { attributes: unknown[] }) => {
  const styles = createStyles(VideoTagsIdentifier, baseStyles);

  const formatTags = attributes
    .filter((value): value is string => typeof value === 'string' && !!value)
    .map((value) =>
      value.split(',').map((label) => (
        <div className={styles.tag} key={label}>
          {label}
        </div>
      )),
    );

  if (!formatTags.length) {
    return null;
  }

  return <div className={styles.tagContainer}>{formatTags}</div>;
};

export default VideoTags;
